interface STEMForgeLogoProps {
  className?: string;
  height?: number;
  gradientId?: string;
}

export default function STEMForgeLogo({
  className = '',
  height = 40,
  gradientId = 'stemforge-grad',
}: STEMForgeLogoProps) {
  return (
    <svg
      viewBox="0 0 1080 1080"
      style={{ height, width: 'auto' }}
      className={className}
      aria-label="STEMForge Tech Labs"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="237.72"
          y1="540"
          x2="842.28"
          y2="540"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#06733c" />
          <stop offset="1" stopColor="#5f9f43" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        fillRule="evenodd"
        d="M559.32,363.77h0l97.91,56.53c20.58,11.88,43.8,11.87,64.37-.02l88.48-51.08c4.21-2.43,6.44-6.3,6.44-11.15s-2.23-8.73-6.44-11.15l-237.88-137.34c-20.59-11.89-43.81-11.89-64.4,0l-237.88,137.34c-20.59,11.89-32.2,32-32.2,55.77v197.87c0,4.86,2.24,8.73,6.44,11.15,4.21,2.43,8.67,2.43,12.88,0l88.48-51.08c28.55-16.48,61.58-16.5,90.13-.02l177.31,102.37c4.1,2.36,6.44,6.43,6.44,11.15s-2.34,8.79-6.44,11.15l-53.64,30.97c-12.29,7.09-26.35,7.09-38.64,0h0l-97.91-56.53c-20.58-11.88-43.8-11.87-64.37.02l-88.48,51.08c-4.21,2.43-6.44,6.3-6.44,11.15s2.23,8.73,6.44,11.15l237.88,137.34c20.59,11.89,43.81,11.89,64.4,0l237.88-137.34c20.59-11.89,32.2-32,32.2-55.77v-197.87c0-4.86-2.24-8.73-6.44-11.15-4.21-2.43-8.67-2.43-12.88,0l-88.48,51.08c-28.55,16.48-61.58,16.5-90.13.02l-177.31-102.37c-4.1-2.36-6.44-6.43-6.44-11.15s2.34-8.79,6.44-11.15l53.64-30.97c12.29-7.09,26.35-7.09,38.64,0h0Z"
      />
    </svg>
  );
}
